import React, { Component } from "react";
import { Link } from "react-router-dom";
import LogoSlider from "../../components/LogoSlider/LogoSlider";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import './Home.css';

export default class Home extends Component {
  render() {
    return (
      <div className="home-container">
        {/* Hero Banner Section */}
        <div className="hero-banner">
          <img
            src="./assets/images/homepage.png"
            alt=""
            className="hero-image"
          />
          <div className="hero-text-container">
            <p className="hero-text-content">
              <span className="hero-text-highlight">Complexity</span> made Simple{" "}
              <br />
              with <span className="hero-text-highlight">Powerful Solutions</span>
            </p>
          </div>
        </div>

        {/* Logo Slider */}
        <div className="logo-slider-container">
          <LogoSlider />
        </div>

        {/* Introduction Section */}
        <div className="intro-section">
          <h1 className="intro-heading">
            INNOVATING TECHNOLOGY <br /> EMPOWERING BRANDS
          </h1>
          <p className="intro-description">
            Ambrum is the parent company based in Sri Lanka with roots overseas.{" "}
            <br className="desktop-only" />
            The versatility of our product offering has evolved exponentially
            over the years as we are now capable of{" "}
            <br className="desktop-only" />
            delivering dynamic products to a multitude of{" "}
            <br className="desktop-only" />
            companies locally and globally.
          </p>
          <Link to="/talk-to-us" className="consultation-btn-link">
            <button className="primary-btn">
              Book a free consultation
            </button>
          </Link>
          <h2 className="section-heading mt-5 mb-4">WHAT WE DO</h2>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {/* Row 1 */}
          <div className="service-row  py-md-5">
            <Link to="/services/software-mobile" className="service-card service-card-left">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/menu.gif" className="service-icon" alt="Software Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">
                    Custom Software & Mobile App Development
                  </h3>
                  <p className="service-description">
                    Scalable web & mobile solutions tailored to business needs
                  </p>
                </div>
              </div>
            </Link>
            <Link to="/services/sub-services?service=brand-strategy" className="service-card service-card-right">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/flow-chart-1.gif" className="service-icon" alt="Brand Strategy Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">Brand Strategy & Identity Development</h3>
                  <p className="service-description">Positioning, branding, and creative identity design</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Row 2 - Full Width */}
          <div className="service-row-full py-md-5">
            <Link to="/services/sub-services?service=smart-city" className="service-card-full">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/map.gif" className="service-icon" alt="Smart City Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">Smart City & Infrastructure Solutions</h3>
                  <p className="service-description">Digital ecosystems for smart city management...</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Row 3 */}
          <div className="service-row py-md-5">
            <Link to="/services/sub-services?service=digital-marketing" className="service-card service-card-left">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/encryption.gif" className="service-icon" alt="Digital Marketing Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">Performance-Driven Digital Marketing</h3>
                  <p className="service-description">ROI-focused campaigns. Data-driven SEO & paid advertising strategies</p>
                </div>
              </div>
            </Link>
            <Link to="/services/sub-services?service=e-ticketing" className="service-card service-card-right">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/tickets.gif" className="service-icon" alt="E-Ticketing Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">E-Ticketing & Event Management Solutions</h3>
                  <p className="service-description">Seamless ticketing, booking, and event coordination systems</p>
                </div>
              </div>
            </Link>
          </div>

          {/* Row 4 - Full Width */}
          <div className="service-row-full py-md-5">
            <Link to="/services/sub-services?service=ev-charging" className="service-card-full">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/charging-station.gif" className="service-icon" alt="EV Charging Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">EV Charging & Sustainable Tech Solutions</h3>
                  <p className="service-description">
                    Advanced EV charging software & network management. Smart energy & mobility integration for businesses
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Row 5 - Full Width */}
          <div className="service-row-full py-md-5">
            <Link to="/services/sub-services?service=healthcare" className="service-card-full">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/doctors-office.gif" className="service-icon" alt="Healthcare Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">Healthcare & E-Channeling Solutions</h3>
                  <p className="service-description">
                    Digital platforms for patient booking & medical record tracking.
                    Telemedicine & AI-powered health tech solutions
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Row 6 */}
          <div className="service-row py-md-5">
            <Link to="/services/sub-services?service=social-media" className="service-card service-card-left">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/content-media.gif" className="service-icon" alt="Content Media Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">Content & Social Media Growth</h3>
                  <p className="service-description">
                    High-impact content creation & community engagement.
                    Video production and storytelling
                  </p>
                </div>
              </div>
            </Link>
            <Link to="/services/sub-services?service=e-commerce" className="service-card service-card-right">
              <div className="service-card-content">
                <div className="service-icon-container">
                  <img src="./assets/icons/online-shopping.gif" className="service-icon" alt="E-Commerce Icon" />
                </div>
                <div className="service-text">
                  <h3 className="service-title">E-Commerce & Conversion Optimization</h3>
                  <p className="service-description">
                    Sales funnel development, retention marketing, and automation.
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <ContactUsFooter />
        <Footer />
      </div>
    );
  }
}